// Shared display formatting. These match the copies they replaced exactly,
// quirks included (see format.test.js), so rendered pages don't change.

const weekday = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const monthName = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// "Fri 1 Mar". A date-only string is parsed as UTC but rendered in local time.
export const getPrettyDate = (programDate) => {
  let d = new Date(programDate);
  return weekday[d.getDay()] + " " + d.getDate() + " " + monthName[d.getMonth()];
};

// "1 Mar", used by LatestResultDetail.
export const getPrettyDayMonth = (match_date) => {
  let d = new Date(match_date);
  return d.getDate() + " " + monthName[d.getMonth()];
};

// "1 Mar, 2024", used by PreviousResult.
export const getPrettyDayMonthYear = (match_date) => {
  let d = new Date(match_date);
  return d.getDate() + " " + monthName[d.getMonth()] + ", " + d.getFullYear();
};

// "Tues 2 January" from the UTC date, used for the Live Pool Projections page name.
const liveWeekdays = ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"];
const liveMonths = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const getLivePageDate = (now) => {
  return `${liveWeekdays[now.getUTCDay()]} ${now.getUTCDate()} ${liveMonths[now.getUTCMonth()]}`;
};

// "1234567" becomes "1,234,567".
const groupThousands = (digits) => {
  let grouped = digits.slice(0, digits.length % 3 || 3);
  for (let i = grouped.length; i < digits.length; i += 3) {
    grouped += "," + digits.slice(i, i + 3);
  }
  return grouped;
};

// Groups every run of digits in the string, including any after a decimal point.
export const format_payout_commas = (input) => {
  return input.replace(/\d+/g, groupThousands);
};

// Drops the first two decimals after every run of digits: "12.00" becomes "12".
export const format_decimal_integer = (input) => {
  return input.replace(/(\d+)(?:\.\d{2})?/g, "$1");
};
